import { useContext, useEffect, useState } from "react"
import API from "./API"
import { AdminOrderPersonsResponse, AdminProjectManagerResponse, AdminProjectPersonsResponse, AdminProjectResponse, AdminQueryCenter, AdminQueryOrder, AdminQueryProduct, AdminQueryProject } from "../../backend/src/api/dto"
import { Link, useNavigate, useParams } from "react-router"
import { Controller, useForm } from "react-hook-form"
import DatePicker from 'react-datepicker'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { openClosed, projectFlags, yesNo } from "./constants"
import { lookupNameFromObjectsArray } from "./global"
import AdminAddUserToProject from "./Modal/AdminAddUserToProject"
import AdminAddManagerToProject from "./Modal/AdminAddManagerToProject"
import { ModalContext } from './ModalContext';
import { AdminAddOrderToProjectFunction, AdminAddPersonToProjectFunction, AdminReloadFunction } from "./interfaces"
import ModalConfirmation from "./Modal/Confirmation"
import AdminAddOrderToProject from "./Modal/AdminAddOrderToProject"
import ApiResult from "./ApiResult"
import { UserContext } from './UserContext';
import { ContextType } from './interfaces'
import AdminLevel from "./AdminLevel"

type FormValues = {
    projectId: number
    nameId: string
    name: string
    centerId: number
    ordersIndicator: number
    responsible: string
    customer: string
    billingCustomer: string
    productId: number
    startDate: string
    endDate: string
    status: number
    flag: number
    extraApproval: boolean
}


function Project() {

    const params = useParams();
    let navigate = useNavigate();
    const [apiResult, setApiResult] = useState<null | { status: boolean, message?: string[] }>(null)
    const { currentUser, setCurrentUser } = useContext(UserContext) as ContextType;

    const [data, setData] = useState<{
        project: AdminQueryProject,
        centers: AdminQueryCenter[],
        orders: AdminQueryOrder[],
        products: AdminQueryProduct[],
        projectPersons: AdminProjectPersonsResponse[],
        ordersPersons: AdminOrderPersonsResponse[],
        projectManagers: AdminProjectManagerResponse[]
    }>({
        project: {
            billingCustomer: '',
            centerId: 0,
            divisionId: 0,
            customer: '',
            endDate: '',
            flag: 0,
            name: '',
            nameId: '',
            ordersIndicator: 1,
            productId: 0,
            projectId: 0,
            responsible: '',
            startDate: '',
            status: 1,
            stillWorks: true,
            extraApproval: false
        },
        centers: [],
        orders: [],
        products: [],
        projectPersons: [],
        ordersPersons: [],
        projectManagers: []
    })

    const [showModal, closeModal] = useContext(ModalContext);
    const [visibility, setVisibility] = useState(0);
    const [loading, setLoading] = useState(true)
    const [loading2, setLoading2] = useState(true)
    const { register, control, getValues } = useForm<FormValues>({
        defaultValues: async () => {

            const project = await API.getProject(params.projectId ?? 0)
            setData(prevData => {
                return {
                    ...prevData,
                    project: project.project,
                    orders: project.orders,
                    projectPersons: project.projectPersons,
                    ordersPersons: project.ordersPersons,
                    projectManagers: project.projectManagers
                }

            })
            setLoading(false)
            return project.project
        }
    })

    const reloadData = (): Promise<any> => {
        return API.getProject(params.projectId ?? 0).then(project => {
            setData(prevData => {
                return {
                    ...prevData,
                    orders: project.orders,
                    projectPersons: project.projectPersons,
                    ordersPersons: project.ordersPersons,
                    projectManagers: project.projectManagers
                }
            })
        })
    }

    const addPerson: AdminAddPersonToProjectFunction = (personId, startDate, endDate) => {
        return API.addPersonToProject(params.projectId ?? 0, personId, startDate, endDate)
    }

    const removePerson = (personId: number | string) => {
        return API.deletePersonFromProject(params.projectId ?? 0, personId).then(() => {
            return reloadData()
        })
    }

    useEffect(() => {
        setLoading2(true)
        Promise.all([
            API.getCenters(),
            API.getProducts(),
        ]).then(res => {
            setData(prevData => {
                return {
                    ...prevData,
                    centers: res[0],
                    products: res[1],

                }

            })
            setLoading2(false)
        })
    }, [])

    const addProject = () => {
        API.addProject(getValues()).then((res) => {
            setApiResult(null)
            navigate('/dashboard/project')
        }).catch((e) => {
            setApiResult(e)
        })
    }

    const saveProject = () => {
        API.saveProject(params.projectId ?? 0, getValues()).then((res) => {
            setApiResult(null)
            navigate('/dashboard/project')
        }).catch((e) => {
            setApiResult(e)
        })
    }


    const addOrder: AdminAddOrderToProjectFunction = (name, description, withActivities, visible) => {
        return API.addOrderToProject(params.projectId ?? 0, name, description, withActivities, visible)
    }

    const deleteProject = () => {
        return API.deleteProject(params.projectId ?? 0).then((res) => {
            console.log(res)
            setApiResult(null)
            navigate('/dashboard/project')
        }).catch((e) => {
            console.log(JSON.stringify(e))
            setApiResult(e)
        })
    }

    const toggleCalendar = (mask: number) => {
        setVisibility(prevData => prevData ^= mask)
    }



    if (loading || loading2) {
        return (
            <div className="p-3">
                <div className="card">
                    <div className="card-header" style={{ height: '55px' }}>
                        <div className="mt-2">Projekt: ...</div>
                    </div>
                    <div className="card-body">
                        Nahrávam
                    </div>
                </div>
            </div>
        )
    }


    if (!data.centers.filter(c => c.status).length || !data.products.filter(p => p.status).length) {
        return (
            <div className="p-3">
                <div className="card">
                    <div className="card-header" style={{ height: '55px' }}>
                        <div className="mt-2">Projekt: ...</div>
                    </div>
                    <div className="card-body">
                        <div className="alert alert-warning" role="alert"><FontAwesomeIcon fixedWidth size="2x" icon={["fas", "exclamation-triangle"]} /> Nie sú k dispozícii všetky potrebné údaje. Skontrolujte či je pridané aspoň jedno aktívne stredisko ({data.centers.filter(c => c.status).length}) a produkt ({data.products.filter(p => p.status).length}).</div>
                    </div>
                </div>
            </div>
        )
    }


    return (
        <div className="p-3">
            <div className="card">
                <div className="card-header " style={{ height: '55px' }}>
                    <div className="row">
                        <div className="col-1">
                            <span className=""><Link to="/dashboard/project" className="btn btn-primary"><FontAwesomeIcon fixedWidth icon={["fas", "arrow-left"]} /> Späť</Link></span>
                        </div>
                        <div className="col-6">
                            <div className="mt-2">Projekt: <strong>{
                                params.projectId === "0" ? '[ Vytvoriť nový ]' : getValues().name
                            }</strong></div>
                        </div>
                        <div className="col-5 text-end">
                            <AdminLevel level={9} match="greaterOrEqual">
                                {
                                    params.projectId === "0" ?
                                        <button className="btn btn-primary" onClick={addProject}><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} />  Pridať projekt</button>
                                        :
                                        <>
                                            {
                                                !loading && !data.orders.length ?
                                                    <button className="btn btn-danger ms-3" onClick={() => showModal(
                                                        <ModalConfirmation
                                                            confirm={deleteProject}
                                                            title={"Naozaj zmazať projekt?"}
                                                            text="" />
                                                    )}><FontAwesomeIcon fixedWidth icon={["fas", "trash"]} />  Zmazať projekt</button>
                                                    : null
                                            }
                                            <button className="btn btn-primary  ms-3" onClick={saveProject}><FontAwesomeIcon fixedWidth icon={["fas", "floppy-disk"]} />  Uložiť projekt</button>
                                        </>
                                }
                            </AdminLevel>
                        </div>
                    </div>
                </div>
                <div className="card-body">

                    <ApiResult errorObject={apiResult} />

                    <div className="row">
                        <div className="col-4">
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">ID Projektu</label>
                                </div>
                                <div className="col-auto">
                                    <input type="text" {...register("nameId")} className="form-control form-control-sm" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Názov</label>
                                </div>
                                <div className="col-8">
                                    <input type="text" {...register("name")} className="form-control form-control-sm" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Stredisko</label>
                                </div>
                                <div className="col-auto">
                                    <select {...register("centerId")} className="form-select form-select-sm" >
                                        <option value={0}>[ Vyberte ]</option>
                                        {
                                            data.centers.filter(item => {
                                                return currentUser.settings.showInactive || (!currentUser.settings.showInactive && item.status)
                                            }).map(center => {
                                                return (
                                                    <option value={center.centerId}>{center.name}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Komponenty</label>
                                </div>
                                <div className="col-auto">
                                    <select {...register("ordersIndicator")} className="form-select form-select-sm" >
                                        {
                                            yesNo.map(yn => {

                                                if (params.projectId !== "0" && data.project.ordersIndicator === 1 && yn.id == 0) {
                                                    return (
                                                        <option disabled value={yn.id}>{yn.name} (nie je už možné zmeniť)</option>
                                                    )
                                                } else {
                                                    return (
                                                        <option value={yn.id}>{yn.name}</option>
                                                    )
                                                }

                                            })
                                        }
                                    </select>



                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Vyžaduje schválenie PM</label>
                                </div>
                                <div className="col-auto">
                                    <select {...register("extraApproval")} className="form-select form-select-sm" >
                                        {
                                            yesNo.map(oc => {
                                                return (
                                                    <option value={oc.id}>{oc.name}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Zodpovedný</label>
                                </div>
                                <div className="col-8">
                                    <input type="text" {...register("responsible")} className="form-control form-control-sm" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Zákazník</label>
                                </div>
                                <div className="col-8">
                                    <input type="text" {...register("customer")} className="form-control form-control-sm" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Zákazník VF</label>
                                </div>
                                <div className="col-8">
                                    <input type="text" {...register("billingCustomer")} className="form-control form-control-sm" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Produkt</label>
                                </div>
                                <div className="col-auto">
                                    <select {...register("productId")} className="form-select form-select-sm" >
                                        <option value={0}>[ Vyberte ]</option>
                                        {
                                            data.products.map(product => {
                                                return (
                                                    <option value={product.productId}>{product.name}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Štart</label>
                                </div>
                                <div className="col-auto">
                                    <Controller
                                        control={control}
                                        name='startDate'
                                        render={({ field }) => (
                                            <>
                                                <div className="input-group">
                                                    <input type="text" className="form-control form-control-sm" value={field.value?.toString().split("T")[0]} onChange={(date) => field.onChange(date)} placeholder="RRRR-MM-DD" />
                                                    <span className="input-group-text" onClick={() => toggleCalendar(1)}><FontAwesomeIcon fixedWidth icon={["fas", "calendar-days"]} /></span>
                                                </div>
                                                <div style={{ position: 'relative' }}>
                                                    {
                                                        visibility & 1 ?
                                                            <div style={{ position: 'absolute', top: '10px', zIndex: 10 }}>
                                                                <DatePicker
                                                                    onChange={
                                                                        (date) => {
                                                                            const isoDateindex = date?.getFullYear() + '-' + ('0' + (date?.getMonth()! + 1)).slice(-2) + '-' + ('0' + date?.getDate()).slice(-2)
                                                                            field.onChange(isoDateindex)
                                                                            toggleCalendar(1)
                                                                        }
                                                                    }
                                                                    selected={field.value ? new Date(field.value) ?? null : null}
                                                                    dateFormat='YYYY-MM-dd'
                                                                    inline
                                                                />
                                                                <svg fill="currentColor" className="react-datepicker__triangle__arrow" aria-hidden="true" width="18" height="16" viewBox="0 0 16 16"><path clip-path="url(#«r4»)" fill="none" stroke-width="3" d="M0,0 H16 L8,8 Q8,8 8,8 Z"></path><path stroke="currentColor" d="M0,0 H16 L8,8 Q8,8 8,8 Z"></path><clipPath id="«r4»"><rect x="-1" y="1" width="18" height="16"></rect></clipPath></svg>
                                                            </div>
                                                            : null
                                                    }
                                                </div>
                                            </>
                                        )}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Koniec</label>
                                </div>
                                <div className="col-auto">
                                    <Controller
                                        control={control}
                                        name='endDate'
                                        render={({ field }) => (
                                            <>
                                                <div className="input-group">
                                                    <input type="text" className="form-control form-control-sm" value={field.value?.toString().split("T")[0]} onChange={(date) => field.onChange(date)} placeholder="RRRR-MM-DD" />
                                                    <span className="input-group-text" onClick={() => toggleCalendar(1)}><FontAwesomeIcon fixedWidth icon={["fas", "calendar-days"]} /></span>
                                                </div>
                                                <div style={{ position: 'relative' }}>
                                                    {
                                                        visibility & 2 ?
                                                            <div style={{ position: 'absolute', top: '10px', zIndex: 10 }}>
                                                                <DatePicker
                                                                    onChange={
                                                                        (date) => {
                                                                            const isoDateindex = date?.getFullYear() + '-' + ('0' + (date?.getMonth()! + 1)).slice(-2) + '-' + ('0' + date?.getDate()).slice(-2)
                                                                            field.onChange(isoDateindex)
                                                                            toggleCalendar(2)
                                                                        }
                                                                    }
                                                                    selected={field.value ? new Date(field.value) ?? null : null}
                                                                    dateFormat='YYYY-MM-dd'
                                                                    inline
                                                                />
                                                                <svg fill="currentColor" className="react-datepicker__triangle__arrow" aria-hidden="true" width="18" height="16" viewBox="0 0 16 16"><path clip-path="url(#«r4»)" fill="none" stroke-width="3" d="M0,0 H16 L8,8 Q8,8 8,8 Z"></path><path stroke="currentColor" d="M0,0 H16 L8,8 Q8,8 8,8 Z"></path><clipPath id="«r4»"><rect x="-1" y="1" width="18" height="16"></rect></clipPath></svg>
                                                            </div>
                                                            : null
                                                    }
                                                </div>
                                            </>
                                        )}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Stav</label>
                                </div>
                                <div className="col-auto">
                                    <select {...register("status")} className="form-select form-select-sm" >
                                        {
                                            openClosed.map(oc => {
                                                return (
                                                    <option value={oc.id}>{oc.name}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Príznak</label>
                                </div>
                                <div className="col-auto">
                                    <select {...register("flag")} className="form-select form-select-sm" >
                                        {
                                            projectFlags.map(oc => {
                                                return (
                                                    <option value={oc.id}>{oc.name}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>




                    {
                        data.project ?
                            data.project.ordersIndicator ?


                                <div className="row mt-5">
                                    <div className="col-6">
                                        <div className="card">
                                            <div className="card-header">
                                                <div className="row">
                                                    <div className="col-6">
                                                        <div className="mt-1 h7"><span className="text-primary me-2"><FontAwesomeIcon fixedWidth icon={["fas", "diagram-project"]} /><FontAwesomeIcon fixedWidth icon={["fas", "arrow-right"]} /><FontAwesomeIcon fixedWidth icon={["fas", "puzzle-piece"]} /></span> Komponenty projektu</div>
                                                    </div>
                                                    <div className="col-6 text-end">
                                                        <AdminLevel level={9} match="greaterOrEqual">
                                                            {
                                                                params.projectId === "0" ?
                                                                    <button className="btn btn-success btn-sm" disabled><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} /> Pridať komponent projektu</button>
                                                                    :
                                                                    <button className="btn btn-success btn-sm" onClick={
                                                                        () => showModal(
                                                                            <AdminAddOrderToProject
                                                                                item={null}
                                                                                reload={reloadData}
                                                                                addFunction={addOrder}
                                                                            />
                                                                        )
                                                                    }><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} /> Pridať komponent projektu</button>
                                                            }
                                                        </AdminLevel>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card-body">
                                                {
                                                    params.projectId !== "0" ?

                                                        <table className="table table-bordered table-sm">
                                                            <thead>
                                                                <tr>
                                                                    <th>Názov</th>
                                                                    <th>Popis</th>
                                                                    <th className="text-center" style={{ width: '200px' }}>Počet osôb</th>
                                                                    <th className="text-center" style={{ width: '130px' }}>Viditeľná</th>
                                                                    <th className="text-center" style={{ width: '130px' }}>Akcia</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {

                                                                    data.orders.map(order => {
                                                                        return (
                                                                            <tr>
                                                                                <td>{order.name}</td>
                                                                                <td>{order.description}</td>
                                                                                <td className="text-center">{
                                                                                    data.ordersPersons.reduce((acc, item) => {
                                                                                        if (item.orderId === order.orderId) {
                                                                                            return acc += 1
                                                                                        }
                                                                                        return acc
                                                                                    }, 0)
                                                                                }</td>
                                                                                <td className="text-center">{lookupNameFromObjectsArray(yesNo, 'id', order.visible)}</td>
                                                                                <td className="text-center">
                                                                                    <Link to={"/dashboard/project/" + params.projectId + "/order/" + order.orderId} className="btn btn-primary btn-sm"><FontAwesomeIcon fixedWidth icon={["fas", "pen"]} /> Upraviť</Link>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }
                                                            </tbody>
                                                        </table>
                                                        :
                                                        <div className="text-center">Bude možné pridať po vytvorení projektu</div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <ProjectManagers project={data.project} projectManagers={data.projectManagers} showModal={showModal} projectId={params.projectId} reloadData={reloadData} />
                                    </div>
                                </div>

                                :

                                <div className="row mt-5">
                                    <div className="col-6">
                                        <div className="card">
                                            <div className="card-header">
                                                <div className="row">
                                                    <div className="col-6">
                                                        <div className="mt-1 h7"><span className="text-primary me-2"><FontAwesomeIcon fixedWidth icon={["fas", "diagram-project"]} /><FontAwesomeIcon fixedWidth icon={["fas", "arrow-right"]} /><FontAwesomeIcon fixedWidth icon={["fas", "person"]} /></span> Osoby priradené k projektu</div>
                                                    </div>
                                                    <div className="col-6 text-end">
                                                        <button className="btn btn-success btn-sm" onClick={

                                                            () => showModal(
                                                                <AdminAddUserToProject
                                                                    item={null}
                                                                    reload={reloadData}
                                                                    alreadyAdded={data.ordersPersons}
                                                                    addFunction={addPerson}
                                                                />
                                                            )

                                                        }><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} /> Pridať osobu k projektu</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card-body">
                                                <table className="table table-bordered table-sm">
                                                    <thead>
                                                        <tr>
                                                            <th>Meno</th>
                                                            <th style={{ width: '100px' }}>Od</th>
                                                            <th style={{ width: '100px' }}>Do</th>
                                                            <th className="text-center" style={{ width: '130px' }}>Akcia</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            data.ordersPersons.map(person => {
                                                                return (
                                                                    <tr>
                                                                        <td>{person.name} {person.surname}</td>
                                                                        <td>{person.fromMonth}&nbsp;.&nbsp;{person.fromYear}</td>
                                                                        <td>{
                                                                            !person.toMonth || !person.toYear ?
                                                                                'Trvá' : <span>{person.toMonth}&nbsp;.&nbsp;{person.toYear}</span>
                                                                        }</td>
                                                                        <td className="text-center">
                                                                            <button className="btn btn-danger btn-sm me-2" onClick={
                                                                                () => showModal(
                                                                                    <ModalConfirmation
                                                                                        confirm={() => removePerson(person.personId)}
                                                                                        title="Potvrdiť odobratie"
                                                                                    ><div>
                                                                                            <table className="table table-bordered">
                                                                                                <tbody>
                                                                                                    <tr>
                                                                                                        <td>Osoba</td>
                                                                                                        <td>{person.name} {person.surname}</td>
                                                                                                    </tr>
                                                                                                    <tr>
                                                                                                        <td>Projekt</td>
                                                                                                        <td>{getValues().name}</td>
                                                                                                    </tr>
                                                                                                </tbody>
                                                                                            </table>
                                                                                        </div>
                                                                                    </ModalConfirmation>
                                                                                )
                                                                            }><FontAwesomeIcon fixedWidth icon={["fas", "trash"]} /> Odobrať</button>

                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <ProjectManagers project={data.project} projectManagers={data.projectManagers} showModal={showModal} projectId={params.projectId} reloadData={reloadData} />
                                    </div>
                                </div>
                            : null
                    }
                </div>
            </div>
        </div>
    )
}

function ProjectManagers({ project,projectManagers, showModal, projectId, reloadData }: {
    project: AdminQueryProject,
    projectManagers: AdminProjectManagerResponse[],
    showModal: Function,
    projectId: string | undefined
    reloadData: AdminReloadFunction
}) {


    const addManager: AdminAddPersonToProjectFunction = (personId) => {
        return API.addManagerToProject(projectId ?? 0, personId)
    }

    const removeManager = (personId: number | string) => {
        return API.deleteManagerFromProject(projectId ?? 0, personId).then(() => {
            return reloadData()
        })
    }


    return (
        <div className="card">
            <div className="card-header">
                <div className="row">

                    <div className="col-6">
                        <div className="mt-1 h7"><span className="text-primary me-2"><FontAwesomeIcon fixedWidth icon={["fas", "diagram-project"]} /><FontAwesomeIcon fixedWidth icon={["fas", "arrow-right"]} /><FontAwesomeIcon fixedWidth icon={["fas", "user-tie"]} /></span> Projektmanažéri priradení k projektu</div>
                    </div>
                    <div className="col-6 text-end">
                        <button className="btn btn-success btn-sm" onClick={
                            () => showModal(
                                <AdminAddManagerToProject
                                    reload={reloadData}
                                    alreadyAdded={projectManagers}
                                    addFunction={addManager}
                                />
                            )
                        }><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} /> Pridať projektmanažéra k projektu</button>
                    </div>
                </div>
            </div>
            <div className="card-body">
                <table className="table table-bordered table-sm">
                    <thead>
                        <tr>
                            <th>Meno</th>
                            <th className="text-center" style={{ width: '130px' }}>Akcia</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            projectManagers.map(person => {
                                return (
                                    <tr>
                                        <td>{person.name} {person.surname}</td>
                                        <td className="text-center">
                                            <button className="btn btn-danger btn-sm me-2" onClick={
                                                () => showModal(
                                                    <ModalConfirmation
                                                        confirm={() => removeManager(person.personId)}
                                                        title="Potvrdiť odobratie"
                                                    ><div>
                                                            <table className="table table-bordered">
                                                                <tbody>
                                                                    <tr>
                                                                        <td>Projektmanažér</td>
                                                                        <td>{person.name} {person.surname}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Projekt</td>
                                                                        <td>{project.name}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </ModalConfirmation>
                                                )
                                            }><FontAwesomeIcon fixedWidth icon={["fas", "trash"]} /> Odobrať</button>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}


export default Project